// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xn-h","newExpiryDate":"styles_newExpiryDate__2uzPn","footer":"styles_footer__Ey50-"};